import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class BreadcrumbsService {

  private activeBreadCrumb = new BehaviorSubject<object>({ 1: {state: true, active: true} });
  resetErrorObservable = this.activeBreadCrumb.asObservable();
  
  public resetBreadCrumb(breadcrumb: object) {
    this.activeBreadCrumb.next(breadcrumb);
  }

}
